import { render, staticRenderFns } from "./downloadComponent.vue?vue&type=template&id=bfba5406&"
import script from "./downloadComponent.vue?vue&type=script&lang=js&"
export * from "./downloadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports